import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  loadingDelete: false,
  pricePromotions: [],
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
  statistics: {
    activePromotions: 0,
    totalExposure: 0,
    avgTakeRate: 0,
  },
  termConditions: [],
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_LOADING: (s, data) => (s.loading = data),
    SET_LOADING_DELETE: (s, data) => (s.loadingDelete = data),
    SET_PRICE_PROMOTIONS: (s, data) => {
      s.pricePromotions = data.pricePromotions;
      s.pagination = data.pagination;
    },
    SET_TERM_CONDITIONS: (s, data) => (s.termConditions = data),
  },

  actions: {
    async getPricePromotions({ commit }, params) {
      commit("SET_LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/promotions", {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_PRICE_PROMOTIONS", {
          pricePromotions: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async updatePricePromotion({ dispatch }, id) {
      try {
        const { data: res } = await this.$api.put(
          `/v1/portal/promotions/${id}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async deletePricePromotion({ dispatch, commit }, id) {
      try {
        commit("SET_LOADING_DELETE", true);
        const { data: res } = await this.$api.delete(
          `/v1/portal/promotions/${id}`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_DELETE", false);
      }
    },
    async getRaceInMeeting({}, meetingId) {
      try {
        const { data: res } = await this.$api.get(`/v1/portal/racing/races`, {
          params: { meetingId, limit: 100 },
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getRunnerInRace({}, raceId) {
      try {
        const { data: res } = await this.$api.get(
          `v1/racing/races/${raceId}/runners`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      }
    },
    async getTermConditions({ commit }) {
      try {
        const { data: res } = await this.$api.get(
          "/v1/portal/promotions/term-conditions/list"
        );
        commit("SET_TERM_CONDITIONS", res.data);
      } catch (e) {
        errorHandler(e);
      }
    },
  },
};
